import { createApp, ref, onMounted, onBeforeUnmount} from 'vue'
import Swal from 'sweetalert2'
import { useI18n } from 'vue-i18n'
import i18n from '../i18n'

const mountEl = document.getElementById('content');


if (mountEl) {
    createApp({
        setup() {
            const { t } = useI18n()

            const memberType = ref('gb'); // 預設為 GAMEBOSS
            const username = ref('');
            const password = ref('');
            const loading = ref(false);
            const turnstileToken = ref('');
            const showPassword = ref(false);
            const cfReady = ref(false);
            const widgetId = ref(null);
            
            const onTurnstileVerified = (token) => {
                turnstileToken.value = token;
                cfReady.value = true; // 在 Composition API 中，使用 .value 來更新 ref
            };

            const onTurnstileExpired = () => {
                console.log("Turnstile Expired");
                turnstileToken.value = ''
                cfReady.value = false;
                if (window.turnstile && widgetId.value) {
                    window.turnstile.reset(widgetId.value);
                    console.log("Turnstile 小工具已重置，等待用戶重新驗證。");
                } 
                else {
                    console.error("無法重置 Turnstile：API 或 Widget ID 遺失。");
                }
            };

            const onTurnstileError = () => {
                console.log("Turnstile Error");
                turnstileToken.value = '';
                cfReady.value = false; // 在 Composition API 中，使用 .value 來更新 ref
                if (window.turnstile && widgetId.value) {
                    window.turnstile.reset(widgetId.value);
                    console.log("Turnstile 小工具已重置，等待用戶重新驗證。");
                } 
                else {
                    console.error("無法重置 Turnstile：API 或 Widget ID 遺失。");
                }
            };
            onMounted(() => {
                const container = document.getElementById('turnstile-container')
                const siteKey = container.dataset.sitekey;

                const initTurnstile = () => {
                    if (!window.turnstile) {
                        console.log("Turnstile API 尚未載入。");
                        return;
                    }

                    const id = window.turnstile.render('#turnstile-container', { 
                        sitekey: siteKey,
                        theme: 'light',
                        callback: onTurnstileVerified,
                        'expired-callback': onTurnstileExpired,
                        'error-callback': onTurnstileError
                    });
                    widgetId.value = id;
                };

                // 檢查 Turnstile API 是否已載入
                if (window.turnstile) {
                    initTurnstile();
                } else {
                    const script = document.querySelector('script[src*="turnstile/v0/api.js"]');
                    if (script) {
                        script.addEventListener('load', initTurnstile);
                    }
                    else{
                        console.error("找不到 Turnstile API 腳本標籤。");
                    } 
                }
            })

            onBeforeUnmount(() => {
                // 清掉全域參考，避免重複註冊
                delete window.onTurnstileVerified
                delete window.onTurnstileExpired
                delete window.onTurnstileError
            })
            
            const submitForm = async () => {
                if (!turnstileToken.value) {
                    // 沒 token -> 先重置讓使用者再驗一次
                    turnstile.reset()
                    return
                }
                if (!username.value.trim() || !password.value.trim()) {
                    Swal.fire({
                        icon: 'warning',
                        title:  t('login.msg_error_title'),
                        text: t('login.logininfo_error'),
                    });
                    return;
                }
            
                const formData = new FormData();
                formData.append('membertype', memberType.value);
                formData.append('username', username.value);
                formData.append('password', password.value);
                formData.append('cf_turnstile_response', turnstileToken.value);
                loading.value = true;
                try {
                    const res = await fetch('/login', {
                        method: 'POST',
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',     // 可選，但很多套件用這個判斷 AJAX
                            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
                        }, 
                        body: formData,
                    })
                    const data = await res.json();
                    if(!data.success){
                        onTurnstileError();
                        Swal.fire({
                            icon: 'error',
                            title:  t('login.msg_error_title'),
                            text:  data?.message || t('login.login_unknow'),
                        });    
                    }
                    else if (data?.data?.url) { 
                         window.location.href = data.data.url
                    } 
                } 
                catch (error) {
                    onTurnstileError();
                    console.log(error);
                    Swal.fire({
                        icon: 'error',
                        title:  t('login.msg_error_title'),
                        text:  error?.response?.data?.message || error.message || error
                    });    
                }
                finally{
                    loading.value = false;
                }
            }
            return { cfReady,memberType,username,showPassword, password, loading, submitForm }
        }
    }).use(i18n).mount('#content') // 👈 每頁都綁定在同一個 #content
    
}


